import styled from 'styled-components'

import { Loader } from '../../atoms/loader'
import { Label } from '../../atoms/label'

import styles from '../card/card.module.css'

const StyledDiv = styled.div`
height: 50px;
border-radius: 10px;
margin-left: 3px;
margin-right: 3px;
background-color: white;
`

export const LoaderCard = props => {
    return <div className={styles.parentContainer}>
        <div className={styles.cardHeader}>
            <label>{props.loading ? 'Loading...' : 'Error'}</label>
        </div>
        <StyledDiv>
            {props.loading
                ? <Loader />
                : <Label error>{props.error}</Label>}
        </StyledDiv>
    </div>
}